/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { Suspense } from "react";
import LoadingIndicator from "../LoadingIndicator";

export interface LoadingIndicatorSuspenseProps {
    children?: React.ReactNode;
}

export default function LoadingIndicatorSuspense(props: LoadingIndicatorSuspenseProps) {
    return (<Suspense fallback={<LoadingIndicator loading/>}>
        {props.children}
    </Suspense>);
}
